import { useMemo } from 'react';
import { TrackingProvider } from '@givelify/utils';
import { CoveredFees } from 'pages/settings';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import LoadingBar from '../components/system/LoadingBar';

import { Campuses } from '../pages/settings/campuses';
import { QuickGive } from '../pages/settings/quickGive';
import { AppState } from '../store';
import { isFeatureEnabled, Features } from '../utils/featureGating';
import { PATH } from './routes';

export const CampusesElement = () => {
    const { doneeType } = useSelector((state: AppState) => ({
        doneeType: state.Donee.donee?.type,
    }));

    return doneeType === 'church' ? (
        <Campuses />
    ) : (
        <Navigate replace to={PATH.SETTINGS.ROOT} />
    );
};

export const QuickGiveElement = () => {
    const isSynagogue = useSelector(
        (state: AppState) => state.User.user?.isSynagogue,
    );
    return isSynagogue ? (
        <QuickGive />
    ) : (
        <Navigate replace to={PATH.SETTINGS.ROOT} />
    );
};

export const SettingsRoutes = () => {
    const enabledFeatures = useSelector(
        (state: AppState) => state.System.enabledFeatures,
    );
    const allSettings = useMemo(
        () => isFeatureEnabled(enabledFeatures, Features.SETTINGS_ALL),
        [enabledFeatures],
    );

    if (enabledFeatures.length === 0) {
        return <LoadingBar show />;
    }

    if (!allSettings) {
        return <Navigate replace to={PATH.NOT_FOUND} />;
    }

    return (
        <TrackingProvider trackPageVisit={false}>
            <Outlet />
        </TrackingProvider>
    );
};

export const CoveredFeesElement = () => {
    const { isDonorCoveredFeeAvailable } = useSelector((state: AppState) => ({
        isDonorCoveredFeeAvailable:
            state.Donee.donee?.isDonorCoveredFeeAvailable,
    }));
    return isDonorCoveredFeeAvailable ? (
        <CoveredFees />
    ) : (
        <Navigate replace to={PATH.SETTINGS.ROOT} />
    );
};
